export default class Autofocus {
	constructor({ elements }) {
		window.addEventListener('DOMContentLoaded', () => {
			elements.forEach((el) => {
				setTimeout(() => {
					if (el) el.focus();
				}, 0);
			});
		});
	}
}
